<template>
  <el-form
      ref="form"
      :model="form"
      label-width="110px">
      <div class="form-row">
        <div class="form-col" v-if="campaignTargetType">
          <el-form-item
              label="广告活动投放类型"
              prop="campaignTargetType"
              :rules="[
                { required: true, message: '请选择投放类型', trigger: ['change'] }
              ]">
            <gj-select
                v-model="form.campaignTargetType"
                :options="spType"
                :clearable="false"
                width="200px"
                placeholder="请选择">
            </gj-select>
          </el-form-item>
        </div>
        <div class="form-col">
          <el-form-item
              label="广告活动名称"
              prop="campaignId"
              :rules="[
                { required: isMeaningless(campaign), message: '请选择广告活动', trigger: ['change'] }
              ]"
              :style="{'margin-bottom': isMeaningful(group) ? '0' : '15px' }">
            <gj-select
                v-if="isMeaningless(campaign)"
                v-model="form.campaignId"
                :options="proxyCampaignOption"
                :loading="campaignLoading"
                width="200px"
                :clearable="false"
                placeholder="请选择"
                @input="campaignChange($event)"
                @input-option="campaignOptionChange($event)">
            </gj-select>
            <template v-else>
              {{campaign.campaignName | defaultShow}}
            </template>
          </el-form-item>
        </div>
        <div class="form-col" v-if="groupSelect">
          <el-form-item
              label="广告组名称"
              prop="groupId"
              :rules="[
                { required: isMeaningless(group), message: '请选择广告组', trigger: ['change'] }
              ]"
              :style="{'margin-bottom': isMeaningful(group) ? '8px' : '15px' }">
            <gj-select
                v-if="isMeaningless(group)"
                v-model="form.groupId"
                :options="proxyGroupOption"
                :loading="groupLoading"
                width="200px"
                :clearable="false"
                placeholder="请选择"
                @input-option="groupOptionChange($event)">
            </gj-select>
            <template v-else>
              {{group.groupName | defaultShow}}
            </template>
          </el-form-item>
        </div>
        <div class="form-col" v-if="groupInput">
          <el-form-item
              label="广告组名称"
              prop="groupName"
              :rules="[
                { required: true, message: '请输入广告组名称', trigger: ['change', 'blur'] }
              ]">
            <gj-input
                v-model="form.groupName"
                width="200px"
                placeholder="请输入">
            </gj-input>
          </el-form-item>
        </div>
      </div>
  </el-form>
</template>

<script>
  import {adBasePropsMixin} from "../../../../../common/mixin";
  import {formMixin, isMeaningfulMixin, isMeaninglessMixin} from "../../../../../../../../minxins";
  import {AdCampaignEnum, AdGroupEnum} from "../../../../../common/enum";
  import {isMeaningful} from "../../../../../../../../utils/common";
  import {getSdAdCampaignList, getSdAdGroupList} from "../../../../../../../../api/ad";

  export default {
    name: "app-base-info",
    mixins: [adBasePropsMixin, formMixin, isMeaninglessMixin, isMeaningfulMixin],
    props: {
      marketId: {
        required: true
      },
      campaignTargetTypeOption: {
        default: () => AdGroupEnum.SD.targetingTypeOption
      },
      campaignOption: {
        default: () => []
      },
      groupOption: {
        default: () => []
      },
      campaignTargetType: {
        type: Boolean,
        default: false
      },
      groupSelect: {
        type: Boolean,
        default: false
      },
      groupInput: {
        type: Boolean,
        default: false
      },
      campaign: {
        required: false,
        default: null
      },
      group: {
        required: false,
        default: null
      }
    },
    data() {
      return {
        AdGroupEnum: AdGroupEnum,
        proxyCampaignOption: [],
        proxyGroupOption: [],
        campaignLoading: false,
        groupLoading: false
      }
    },
    created() {
      this.proxyCampaignOption = this.campaignOption;
      this.proxyGroupOption = this.groupOption;
    },
    watch: {
      'form.campaignTargetType': {
        handler: function(campaignTargetType) {
          if (isMeaningful(campaignTargetType)) {
            this.campaignTargetTypeChange(campaignTargetType);
          }
        },
        immediate: true
      },
      campaign: {
        handler: function(campaign) {
          if (isMeaningful(campaign)) {
            this.form.campaignId = campaign.campaignId;
            this.form.campaignName = campaign.campaignName;
            this.campaignChange(campaign.campaignId);
          }
        },
        immediate: true
      },
      group: {
        handler: function(group) {
          if (isMeaningful(group)) {
            this.form.groupId = group.groupId;
            this.form.groupName = group.groupName;
          }
        },
        immediate: true
      }
    },
    methods: {
      campaignTargetTypeChange(targetingType) {

        if (isMeaningful(this.campaign)) {
          this.proxyGroupOption = [];
          this.form.groupId = null;
          this.form.groupName = null;
          this.campaignChange(this.campaign.campaignId);
          return;
        }

        this.proxyCampaignOption = [];
        this.proxyGroupOption = [];
        this.form.campaignId = null;
        this.form.groupId = null;
        this.form.campaignName = null;
        this.form.groupName = null;
        this.campaignLoading = true;
        getSdAdCampaignList({
          marketId: this.marketId,
          targetingType: targetingType === AdGroupEnum.SD.targetingType.ALL ? null : targetingType,
          state: AdCampaignEnum.SD.status.ARCHIVE
        })
          .then((data) => {
            this.proxyCampaignOption = data.map(e => ({
              id: e.campaignId,
              text: e.campaignName,
              targetingType: e.targetingType
            }));
          })
          .then(() => this.campaignLoading = false);
      },
      campaignChange(campaignId) {

        if (isMeaningful(this.group)) {
          return;
        }

        this.proxyGroupOption = [];
        this.form.groupId = null;
        this.form.groupName = null;
        this.groupLoading = true;
        getSdAdGroupList({
          marketId: this.marketId,
          campaignId,
          targetingType: this.form.campaignTargetType,
          state: AdGroupEnum.SD.status.ARCHIVE
        })
          .then((data) => {
            this.proxyGroupOption = data.map(e => ({
              id: e.groupId,
              text: e.groupName,
              bid: e.defaultBid
            }))
          })
          .then(() => this.groupLoading = false);
      },
      campaignOptionChange(option) {
        if (option) {
          this.form.campaignName = option.text;
          this.$emit('input-campaign-option', option);
        }
      },
      groupOptionChange(option) {
        if (option) {
          this.form.groupName = option.text;
          this.$emit('input-group-option', option);
        }
      },
      formValidate() {
        let formValid = false;
        this.$refs.form.validate((valid) => {
          formValid = valid;
        });
        return formValid;
      }
    }
  }
</script>

<style lang="scss" scoped>
.form-row {
  display: flex;
  flex-wrap: wrap;
  .form-col {
    padding-right: 100px;
  }
}
</style>
